import { aliasForAccount } from "@/lib/account-alias";
import { ACCOUNT_HANDOFF_PARAM } from "@/lib/tab-account";

export function canonicalUrl(href: string = globalThis.location.href): string {
  try {
    const url = new URL(href);
    url.searchParams.delete(ACCOUNT_HANDOFF_PARAM);
    return url.toString();
  } catch {
    return href;
  }
}

export function accountHandoffUrl(href: string, userId: string | null): string {
  if (userId === null) {
    return canonicalUrl(href);
  }
  try {
    const url = new URL(canonicalUrl(href));
    url.searchParams.set(ACCOUNT_HANDOFF_PARAM, aliasForAccount(userId));
    return url.toString();
  } catch {
    return href;
  }
}
